import FormSolicitarVacaciones from "components/solicitudVacaciones/FormSolicitarVacaciones";
import MostrarVacacionesSolicitadas from "components/solicitudVacaciones/MostrarVacacionesSolicitadas";
import React from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

const ViewSolicitarVacaciones = () => {
  return (
    <>
      <Row>
        <Col>
          <Card>
            <CardHeader>Solicitar vacaciones</CardHeader>
            <CardBody> <FormSolicitarVacaciones/> </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardHeader>Pendientes de aprobar</CardHeader>
            <CardBody> 
                <MostrarVacacionesSolicitadas></MostrarVacacionesSolicitadas>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ViewSolicitarVacaciones;
